import $ from 'jquery';

$(function () {

  var storedScrollPosition = localStorage.getItem('scrollPosition');

  if (storedScrollPosition > 50) {
    $(".header-pre").addClass("header-pre--active");
  }

  if (storedScrollPosition > 150) {
    $(".header-main").addClass("header-main--active");
  } else {
    $(".header-main").removeClass("header-main--active");
  }

  if (storedScrollPosition > 350) {
    $(".header-pipeline").addClass("header-pipeline--active");
  } else {
    $(".header-pipeline").removeClass("header-pipeline--active");
  }

  $(window).on("scroll", function() {
    var header = $(window).scrollTop();

    if (header > 50) {
      $(".header-pre").addClass("header-pre--active");
    } else {
      $(".header-pre").removeClass("header-pre--active");
    }

    if (header > 150) {
      $(".header-main").addClass("header-main--active");
    } else {
      $(".header-main").removeClass("header-main--active");
    }

    if (header > 350) {
      $(".header-pipeline").addClass("header-pipeline--active");
    } else {
      $(".header-pipeline").removeClass("header-pipeline--active");
    }

    // Store the current scroll position in localStorage
    localStorage.setItem('scrollPosition', header);
  });

});